import apiEndpoints from '../../../apiEndpoints';
import {
  QuickBookmark,
  QuickBookmarkDraft,
  QuickBookmarkStatus,
} from '../../../types/quickBookmarks';
import { fetcher } from '../../utils/fetchers/fetcher';

export const requestQuickBookmarks = (
  token: string | null
): Promise<{
  items: QuickBookmark[];
  serverNow: string;
}> => fetcher(apiEndpoints.routes.quickBookmarks, 'GET', token);

export const postQuickBookmark = (
  token: string | null,
  body: QuickBookmarkDraft
): Promise<{ item: QuickBookmark }> =>
  fetcher(
    apiEndpoints.routes.quickBookmarks,
    'POST',
    token,
    undefined,
    undefined,
    body
  );

export const patchQuickBookmark = (
  token: string | null,
  id: string,
  body: { reminderAt?: string | null; status?: QuickBookmarkStatus }
): Promise<{ item: QuickBookmark }> =>
  fetcher(
    `${apiEndpoints.routes.quickBookmarks}/${encodeURIComponent(id)}`,
    'PATCH',
    token,
    undefined,
    undefined,
    body
  );
